import { render, staticRenderFns } from "./imEvaluation.vue?vue&type=template&id=db2f992a&scoped=true"
import script from "./imEvaluation.vue?vue&type=script&lang=js"
export * from "./imEvaluation.vue?vue&type=script&lang=js"
import style0 from "./imEvaluation.vue?vue&type=style&index=0&id=db2f992a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2f992a",
  null
  
)

export default component.exports